<template>
  <div>
    <div class="search_box" v-if="$store.getters.tagsView">
      <el-row
        class="top_search_box"
        :class="{ mobile_col_: !$store.getters.tagsView }"
      >
        <el-select
          v-model="companyId"
          placeholder="请选择公司"
          @change="handleSelectCompany"
          class="thead_select h38"
        >
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.companyName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="projectType"
          placeholder="请选择项目类型"
          @change="handleSelectProjectType"
          class="thead_select h38"
        >
          <el-option
            v-for="item in ProjectTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <TotaListNum :total="total" :str="totalStr" unit="个"></TotaListNum>
      </el-row>
      <el-row class="bottom_search_box clearfix">
        <div class="left">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-download"
            @click="handleDownload"
            :loading="downloadLoading"
            >导出</el-button
          >
          <span class="table_select_num" v-if="SelectionNum > 0"
            >已选{{ SelectionNum }}项</span
          >
        </div>
        <div class="right">
          <el-input
            v-model="search.projectCode"
            placeholder="项目编号"
            class="h32 w150h32 mal10"
          ></el-input>
          <el-input
            v-model="search.projectName"
            placeholder="项目名称"
            class="h32 w150h32 mal10"
          ></el-input>
          <el-input
            v-model="search.address"
            placeholder="项目位置"
            class="h32 w150h32 mal10"
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="mal10"
            @click.native="handleSearch"
            size="small"
            >搜索</el-button
          >
        </div>
      </el-row>
    </div>

    <el-row
      class="mat12"
      :class="{ mobile_col_flex: !$store.getters.tagsView }"
      v-if="!$store.getters.tagsView"
    >
      <el-button
        size="small"
        type="primary"
        icon="el-icon-download"
        @click="handleDownload"
        :loading="downloadLoading"
        >导出</el-button
      >
      <span class="table_select_num" v-if="SelectionNum > 0"
        >已选{{ SelectionNum }}项</span
      >
      <!-- 移动端展示 -->
      <div
        class="mobile_model mobile_model_pro"
        v-if="!$store.getters.tagsView"
      >
        <!-- 遮罩层 -->
        <drawer-bg-mask
          :iSmobileSearch="iSmobileSearch"
          @handleCloseSearch="handleCloseSearch"
        ></drawer-bg-mask>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
          "
        >
          <div class="mobile_g_search" @click="handleOpenSearch">
            高级搜索>>
          </div>
        </div>

        <div class="mobile_model_list" v-if="iSmobileSearch">
          <!-- 项目编号 -->
          <el-row :gutter="10">
            <el-col class="table_search_item mat10" :xs="10" :sm="8">
              <el-input
                v-model="search.projectCode"
                placeholder="项目编号"
              ></el-input>
            </el-col>
            <!-- 项目名称 -->
            <el-col class="table_search_item mat10" :xs="10" :sm="8">
              <el-input
                v-model="search.projectName"
                placeholder="项目名称"
              ></el-input>
            </el-col>
            <!-- 手机号码 -->
            <el-col class="table_search_item mat10" :xs="10" :sm="8">
              <el-input
                v-model="search.address"
                placeholder="项目位置"
              ></el-input>
            </el-col>
            <el-col class="table_search_item mat10" :xs="10" :sm="8">
              <el-select
                v-model="companyId"
                placeholder="请选择公司"
                @change="handleSelectCompany"
                class="thead_select"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col class="table_search_item mat10" :xs="10" :sm="8">
              <el-select
                v-model="projectType"
                placeholder="请选择项目类型"
                @change="handleSelectProjectType"
                class="thead_select"
              >
                <el-option
                  v-for="item in ProjectTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-button
            type="primary"
            size="small"
            class="mat10"
            @click.native="handleMobileSearch"
            >搜索</el-button
          >
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import { ProjectTypeList } from '@/utils/config.js'
export default {
  name: 'TableRelatedSearch',
  props: {
    totalStr: { // 统计标题
      type: String,
      default: ''
    },
    totalUnit: { // 统计单位
      type: String,
      default: '个'
    },
    total: { // 总数
      type: Number,
      default: 0
    },
    companyList: {
      type: Array,
      default: () => {
        return []
      }
    },
    companyId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      // companyId: '', // 公司id
      ProjectTypeList, // 项目列表
      projectType: '',
      downloadLoading: false, // 导出时候加载状态
      SelectionNum: null, // 选择的数量
      iSmobileSearch: false, // 遮罩
      search: {
        name: '',
        projectName: '', // 项目名称
        address: '', // 项目位置
        projectCode: '' // 项目编号
      }
    }
  },
  created () {
  },
  methods: {
    //   下拉选择公司信息
    handleSelectCompany (val) {
      this.$emit('select-company', val)
    },
    // 下拉选择项目信息
    handleSelectProjectType (val) {
      this.$emit('select-project-type', val)
    },
    // 点击搜索
    handleSearch () {
      this.$emit('search', this.search)
    },
    // 点击移动端的搜索功能
    handleMobileSearch () {
      this.iSmobileSearch = false
      this.handleSearch()
    },
    // 点击高级搜索
    handleOpenSearch () {
      this.iSmobileSearch = true
    },
    // 关闭遮罩层
    handleCloseSearch () {
      this.iSmobileSearch = false
    },
    // 导出
    handleDownload () {
      this.$emit('download')
    }
  }
}
</script>

<style lang="scss" scoped>
$service_color:#CFA600;
$staff_color: #008AF5;

.table_search {
  display: flex;
  margin-bottom: 12px;

  .table_search_item {
    margin-right: 12px;

    .search_item_date {
      width: 150px;
    }

    .search_item_to {
      padding: 0 10px;
    }

    .rotate_top {
      transform: rotate(90deg);
    }

    .rotate_bottom {
      transform: rotate(270deg);
    }
  }

  .table_search_search {
    margin: 0 16px 0 4px;

    .table_search_search_btn {
      width: 90px;
      height: 38px;
      padding: 0;
    }
  }
}

.table_select_num {
  vertical-align: middle;
  margin-left: 20px;
  color: #67c23a;
  font-size: 13px;
}

.mobile_model_pro {
  .table_search_item {
    .el-input {
      width: 100%;
    }
  }
}

.sort_info {
  float: right;
  display: flex;
  align-items: center;
  line-height: 32px;
  margin-right: 50px;
  span{
    font-size: 14px;
  }
}

@media screen and ( max-width:1090px ){
  .sort_info{
    float:left;
    margin-top:10px;
  }
}
</style>
